aha-pill {
  max-width: 100%;
}

.wrapper {
  display: flex;
  align-items: center;
  max-width: 100%;
}

aha-avatar {
  margin-left: -0.75em;
  margin-right: var(--spacer);
  flex: none;
}

.username {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* This is a fix for a very odd browser behaviour. Basically, an element with
 * display: flex whos first child has no content, will not vertically align with
 * other content on the same line as that item.
 *
 * Here is an example:

  <style
    .a, .b {
      display: inline-block;
    }

    .wrapper {
      background-color: teal;
      display: flex;
      align-items: center;

    }

    .pill {
      height: 40px;
      width: 40px;
    }
  </style>

  <div>
    <span class="a"><span class="pill">abc</span></span>
    <span class="b">
      <span class="c">
        <span class="pill">
          <span class="wrapper">
            <span></span>
            <span>lksjdfkj</span>
          </span>
        </span>
      </span>
    </span>
  </div>
 */
.wrapper:before {
  content: '\200B';
}
